import { motion } from "framer-motion";
import { LineReveal } from "../lib/motionx";
import { useLang } from "../i18n";

export const SectionLabel = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-teal ${className}`}
  >
    <span className="h-px w-6 bg-teal/50" />
    {children}
  </span>
);

export const PageHeader = ({ label, titleLines, intro }) => {
  const { t } = useLang();
  return (
    <section className="pt-28 sm:pt-32 pb-10 sm:pb-14">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {label && <SectionLabel className="mb-5">{t(label)}</SectionLabel>}
        <LineReveal
          lines={titleLines.map((l) => t(l))}
          className="font-heading font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-4xl"
        />
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="mt-6 max-w-2xl text-lg text-ink/65 leading-relaxed"
          >
            {t(intro)}
          </motion.p>
        )}
      </div>
    </section>
  );
};
